import { initializeApp } from 'firebase/app';
import { logger } from '../utils/logger';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDFpsjBC8U_Wk1vAgft57mE0Egj191_Y68",
  authDomain: "tabmemo-9d69c.firebaseapp.com",
  databaseURL: "https://tabmemo-9d69c-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "tabmemo-9d69c",
  storageBucket: "tabmemo-9d69c.firebasestorage.app",
  messagingSenderId: "264794825183",
  appId: "1:264794825183:web:0837ab7bd7038e66aa246a"
};

let app;
let auth;
let db;
let storage;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);

  // Configuration pour les emails de réinitialisation
  auth.languageCode = 'fr'; // Définir la langue française pour les emails

  logger.info('Firebase initialisé avec succès', {
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain,
    environment: process.env.NODE_ENV
  });
  
} catch (error) {
  logger.error('Erreur lors de l\'initialisation de Firebase', error);
  console.error('❌ [Firebase] Erreur d\'initialisation:', error);
  throw error;
}

export { app, auth, db, storage };
